export default __webpack_public_path__ + "static/media/right-arrow-grey.ba1feb6f.svg";